import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Instagram, Twitter } from 'lucide-react';
import { Wordmark } from './Wordmark';

export const Footer = () => {
  return (
    <footer className="border-t border-border bg-card mt-auto">
      <div className="max-w-5xl mx-auto px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-2">
              <Wordmark text="gathered things" textClass="text-chilli group-hover:text-chilli-deep" squiggleClass="text-mustard" size="text-xl" />
            </Link>
            <p className="text-muted-foreground text-sm">
              A marketplace designed for neurodivergent creators.
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="text-muted-foreground hover:text-foreground transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="text-muted-foreground hover:text-foreground transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Shop */}
          <div>
            <h4 className="font-heading font-bold mb-4">Shop</h4>
            <div className="flex flex-col gap-2 text-sm">
              <Link to="/browse?category=crochet" className="text-muted-foreground hover:text-foreground transition-colors">Crochet</Link>
              <Link to="/browse?category=stickers" className="text-muted-foreground hover:text-foreground transition-colors">Stickers</Link>
              <Link to="/browse?category=art" className="text-muted-foreground hover:text-foreground transition-colors">Art</Link>
              <Link to="/browse?category=keyrings" className="text-muted-foreground hover:text-foreground transition-colors">Keyrings</Link>
            </div>
          </div>

          {/* For Creators */}
          <div>
            <h4 className="font-heading font-bold mb-4">For Creators</h4>
            <div className="flex flex-col gap-2 text-sm">
              <Link to="/register" className="text-muted-foreground hover:text-foreground transition-colors">Start Selling</Link>
              <Link to="/dashboard" className="text-muted-foreground hover:text-foreground transition-colors">Creator Dashboard</Link>
              <Link to="/community" className="text-muted-foreground hover:text-foreground transition-colors">Creator Community</Link>
            </div>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-heading font-bold mb-4">Support</h4>
            <div className="flex flex-col gap-2 text-sm">
              <a href="#" className="text-muted-foreground hover:text-foreground transition-colors">Help Centre</a>
              <a href="#" className="text-muted-foreground hover:text-foreground transition-colors">Contact Us</a>
              <a href="#" className="text-muted-foreground hover:text-foreground transition-colors">Privacy Policy</a>
            </div>
          </div>
        </div>

        <div className="border-t border-border mt-8 pt-8 text-center text-sm text-muted-foreground">
          <p className="flex items-center justify-center gap-1">
            Made with <Heart className="w-4 h-4 text-primary fill-primary" /> for neurodivergent creators
          </p>
          <p className="mt-2">&copy; 2026 Gathered Things. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
